import '../App.css';
import Banner from '../components/2510/banner';
import CardPanel from '../components/2510/card-panel';
import Chatbot from '../components/2510/chatbot';
import DocsPanel from '../components/2510/docs-panel';
import CentralPanel from '../components/2510/central-panel';
import HighlightPanel from '../components/2510/highlight-panel';
import ContentBoxPanel from '../components/2510/content-box-panel';
import ThemeToggle from '../components/shared/theme-toggle';
import LanguageToggle from '../components/shared/language-toggle';
import VersionsLink from '../components/shared/versions-link';
import { useReleaseTheme } from '../theme/useReleaseTheme';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

function Release2510Page() {
  useReleaseTheme('2510');
  useDocumentTitle('2510');
  return (
    <div className="App">
      <ThemeToggle />
      <LanguageToggle />
      <VersionsLink />
      <Banner />
      <div className="white-background">
        <CardPanel />
      </div>
      <div className="gray-background">
        <HighlightPanel />
      </div>
      <div className="white-background">
        <DocsPanel />
      </div>
      <div className="gray-background">
        <ContentBoxPanel />
      </div>
      <div className="white-background">
        <CentralPanel />
        <div className="footer-space"></div>
      </div>
      <Chatbot />
    </div>
  );
}

export default Release2510Page;
